import { PageHeader } from "@ant-design/pro-components";
import { Avatar, Button, Card } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import styles from "./Home.module.css";
import * as actions from "../../../store/actions/action";
import { connect } from "react-redux";
import CheckPermission from "../../../Util/CheckPermission";
import { useEffect, useState } from "react";
import api from "../../../api/api";

const Home = ({ userData, permissions, onLogout }) => {
  const [credits, setCredits] = useState([]);

  const creditTypes = ["", "ریال", "تومان", "پیامک"];

  useEffect(() => {
    if (CheckPermission("sms_credit_list", permissions)) {
      getCredits();
    }
  }, [permissions]);

  const getCredits = () => {
    api
      .get("/smscredit/list")
      .then((response) => {
        setCredits(response.data);
      })
      .catch((exception) => {
        setCredits(exception.response.data);
      });
  };

  return (
    <div className={styles.Home}>
      <PageHeader title="خانه" avatar={{ icon: <HomeOutlined />, size: "large" }} />

      <div className={styles.Cards}>
        {CheckPermission("sms_credit_list", permissions) && (
          <Card className={styles.HomeCard} title="شارژ پنل پیامکی" loading={credits ? false : true}>
            {credits &&
              credits.map((credit) => (
                  <div className={styles.FlexRow}>
                    <h2 className={styles.Username}>
                      {credit.title}: {credit.value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} {creditTypes[credit.type]}
                    </h2>
                  </div>
              ))}
          </Card>
        )}

        <Card className={styles.HomeCard} title="اطلاعات کاربری" loading={userData ? false : true}>
          {userData ? (
            <>
              <div className={styles.FlexRow}>
                {" "}
                <Avatar size="large" />
                <h1 className={styles.Username}>{userData.username}</h1>
              </div>
              <p>{userData.email}</p>
              <Button onClick={onLogout} danger>
                خروج
              </Button>
            </>
          ) : null}
        </Card>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    permissions: state.userData ? state.userData.permissions : [],
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    onLogout: () => dispatch(actions.Logout()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Home);
